import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import {
  ExtendedFlex,
  Drawer,
  Content,
} from '../../coreui';

import FadeIn from '../../components/FadeIn';
import ScrollToHash from '../../components/ScrollToHash';

// eslint-disable-next-line
class ThingsYouShouldKnow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.setRef = this.setRef.bind(this);
    this.hashes = [];
    this.els = [];
  }

  setRef(el, name) {
    if (!this.els[name] && el) {
      this.els[name] = el;
    }
  }

  render() {
    const {
      faqItems,
    } = this.props;

    const hashReplace = {
      feesexpenses: 'fees',
    };
    return (
      <ExtendedFlex
        justify="center"
        align="center"
        flexDirection="column"
        w={1}
      >
        <FadeIn>
          {
            faqItems &&
            faqItems.map(
              (item) => {
                let hash = item.header.replace(/[\W_]+/g, '').toLowerCase();
                let i = 0;
                if (hashReplace[hash]) {
                  hash = hashReplace[hash];
                }
                while (this.hashes[hash]) {
                  hash = `${hash}_${i}`;
                  i += 1;
                }
                const thisA = this;
                this.hashes[hash] = function () {
                  if (thisA.els[hash]) {
                    thisA.els[hash].toggleDrawer();
                  }
                };
                return (
                  <ScrollToHash
                    name={hash}
                    offset={-90}
                    onComplete={this.hashes[hash]}
                    wrapper={false}
                  >
                    <Drawer
                      key={`tysk_${item.id}`}
                      title={item.header}
                      ref={(el) => { this.setRef(el, hash); }}
                    >
                      <Content>
                        {ReactHtmlParser(item.content)}
                      </Content>
                    </Drawer>
                  </ScrollToHash>
                );
              },
            )
          }
        </FadeIn>
      </ExtendedFlex>
    );
  }
}

ThingsYouShouldKnow.propTypes = {
  faqItems: PropTypes.array,
};

export default ThingsYouShouldKnow;
